import loadable from '@loadable/component';
import React from 'react';
import {useSelector} from 'react-redux';

import * as productRegistrationStatusTypes from '../../consts/product/productRegistrationStatusTypes';
import {makeSelectCurrentProductToChangeRegistrationStatus} from '../../state/selectors/productSettings';

const ProductRegisteringStatus = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ './ProductRegisteringStatus/ProductRegisteringStatus')
);
const ProductUnregisteringStatus = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ './ProductUnregisteringStatus/ProductUnregisteringStatus')
);

const ProductRegistrationStatus = ({isHolder = false}) => {
    const currentProductToChangeRegistrationStatus = useSelector(
        makeSelectCurrentProductToChangeRegistrationStatus(isHolder)
    );

    if (!currentProductToChangeRegistrationStatus) return null;

    const Component =
        currentProductToChangeRegistrationStatus.status === productRegistrationStatusTypes.REGISTERING
            ? ProductRegisteringStatus
            : ProductUnregisteringStatus;

    return (
        <Component
            productToChangeRegistrationStatus={currentProductToChangeRegistrationStatus}
            key={currentProductToChangeRegistrationStatus.deviceSerialNumber}
        />
    );
};

export default ProductRegistrationStatus;
